<template>
    <!-- cart table template -->
    <p style="text-align:center;" v-show="Cart.CartItems == null || Cart.CartItems.length == 0">{{getInterfaceText('shop_cart_empty')}}</p>
    <p class="sr-only">{{getInterfaceText('shoppingcart')}}</p>
    <table id="cart-table" class="table" v-show="Cart.CartItems != null && Cart.CartItems.length > 0">
        <thead>
            <tr>
                <th class="product" scope="col">{{getInterfaceText('shop_product')}}</th>
                <th class="hidden-xs"></th>
                <th class="price hidden-xs" scope="col">{{getInterfaceText('shop_price')}}</th>
                <th class="quantity" scope="col"><span class="full-label">{{getInterfaceText('shop_quantity')}}</span><span class="short-label">{{getInterfaceText('shop_qty')}}</span></th>
                <th class="total" scope="col">{{getInterfaceText('shop_total')}}</th>
                <th v-if="editMode" class="action" scope="col">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in Cart.CartItems" id="cartItem-{{item.Product.Partnumber.Code}}" :key="item.Id" :class="item.BundleCartItemIds != null && item.BundleCartItemIds.length > 0 ? 'hasSupplementaryCartItem' : item.ParentId > 0 ? 'isBundleItem' : 'cartItem'">
                <th scope="row" class="product-image hidden-xs" nowrap="nowrap" :rowspan="item.BundleCartItemIds != null && item.BundleCartItemIds.length > 0 ? item.BundleCartItemIds.length + 1 : 1" v-show="item.ParentId == 0">

                    <div class="image" :class="item.GiftcardsRecipient != null ? 'image-giftcard' : ''">
                        <img v-if="item.IsGlobalCatalogue" :alt="item.Product.Name" :src="item.Product.Image">
                        <img v-if="item.IsGlobalCatalogue == false" :alt="item.Product.Name" :src="item.Product.Image + '?quality=80&amp;width=100&amp;height=80&amp;mode=pad&amp;bgcolor=white&amp;anchor=middlecenter'" style="max-width:100px;max-height:80px;">
                    </div>

                </th>
                <td class="product-name text-left">
                    <div class="product-name-only">
                        <a :href="item.Product.UrlLabel" rel="nofollow"><span v-if="item.ParentId > 0" class="supplementary-plus"><i class="glyphicon glyphicon-plus"></i></span> {{item.Product.Name}}</a><br />
                    </div>
                    <div class="product-color" v-if="item.Product.Partnumber.Color != null">{{item.Product.Partnumber.Color}}</div>
                    <div class="product-size" v-if="item.Product.Partnumber.Size != null">{{item.Product.Partnumber.Size}}</div>
                    <div class="product-usage" v-if="item.Product.Partnumber.Usage != null">{{item.Product.Partnumber.Usage}}</div>
                    <div class="product-sale" v-if="item.Product.IsCloseOutSale && item.Product.IsSale" style="color: #b50000 !important;">{{getInterfaceText('shop_iscloseoutsale_message')}}</div>
                    <div v-if="item.GiftcardsRecipient != null" style="font-size:1.4rem;"><span class="giftcard-label">{{getInterfaceText('giftcard_recipient')}}:</span> {{item.GiftcardsRecipient}}</div>
                    <div v-if="item.GiftcardsSenddate != null" style="font-size:1.4rem;"><span class="giftcard-label">{{getInterfaceText('giftcard_send')}}:</span> {{item.GiftcardsSenddate}}</div>

                    <div class="stock-info">
                        <span class="stock {{item.Stock.CssClass}}" v-show="item.Stock.Code == 3">{{item.Stock.Label}}</span>
                    </div>
                </td>
                <td class="product-price hidden-xs"><span style="white-space: nowrap;">{{item.Product.Partnumber.Price}}</span></td>
                <td class="product-quantity">
                    <div v-if="item.ParentId == 0">
                        <template v-if="editMode">
                            <div class="btn-group" role="group" aria-label="Quantity" v-show="item.Product.ProductTypeId != 3">
                                <button v-on:click="updateCartItem(item, -1)" type="button" class="btn btn-default update-cart-item" :aria-label="getInterfaceText('shop_decrease_quantity')"><i class="glyphicon glyphicon glyphicon-minus" aria-hidden="true"></i></button>
                                <span class="btn btn-default btn-disable" :aria-label="getInterfaceText('shop_cart_quantity')"><span class="cartItem-quantity">{{item.Quantity}}</span></span>
                                <button v-on:click="updateCartItem(item, 1)" type="button" class="btn btn-default update-cart-item" :aria-label="getInterfaceText('shop_increase_quantity')"><i class="glyphicon glyphicon glyphicon-plus" aria-hidden="true"></i></button>
                            </div>
                        </template>
                        <template v-else>
                            <span class="cartItem-quantity">{{item.Quantity}}</span>
                        </template>
                    </div>
                    <p class="visible-xs" style="padding-top:10px;" v-if="editMode">
                        <button type="button" class="btn-link remove-cart-item" v-on:click="removeCartItem(item)" style="color:inherit;font-size:smaller" aria-label="getInterfaceText('shop_removethisitem')"><i class="glyphicon glyphicon-trash" aria-hidden="true"></i></button>
                    </p>
                    <div v-if="item.ParentId > 0">
                        <span class="cartItem-quantity">{{item.Quantity}}</span>
                    </div>
                </td>
                <td class="orderrow-total">
                    <span style="white-space: nowrap;">
                        <span class="sr-only">{{getInterfaceText('shop_price')}} {{item.TotalToFormat}}</span>
                        <span class="sr-only" v-if="item.TotalOriginalPriceToFormat && item.TotalOriginalPriceToFormat.length > 0">{{getInterfaceText('shop_price_original')}} {{item.TotalOriginalPriceToFormat}}</span>
                        <div class="cartItem-total">{{item.TotalToFormat}}</div>
                        <span class="cartItem-total oldprice">{{item.TotalOriginalPriceToFormat}}</span>
                    </span>
                </td>
                <td class="remove hidden-xs" v-if="editMode">
                    <button type="button" class="btn-link remove-cart-item" v-on:click="removeCartItem(item)" style="color:inherit;font-size:smaller" aria-label="getInterfaceText('shop_removethisitem')"><i class="glyphicon glyphicon-trash" aria-hidden="true"></i></button>
                </td>
            </tr>
        </tbody>
    </table>

    <template v-if="!summaryMode">
        <div class="discountContainer fluid-table-row clearfix" v-show="Cart.Discount > 0">
            <div class="discountlabel col-md-8 col-sm-8 col-xs-8">{{getInterfaceText('shop_discount')}}<span v-show="!Cart.Coupon">: {{Cart.DiscountName}}</span></div>
            <div class="discountlabel col-md-4 col-sm-4 col-xs-4 text-right">- <span class="cart-discount">{{Cart.DiscountToFormat}}</span></div>
        </div>
        <div class="fluid-table-row clearfix" v-show="Cart.ShippingType != 'giftcard'">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{getInterfaceText('shop_shippingcosts')}} <span id="shippingLabel">- {{Cart.ShippingName}}</span>
                <p v-show="Cart.ShippingLabel && Cart.ShippingLabel.length > 0" class="shipping-label">({{Cart.ShippingLabel}})</p>
                <p v-show="Cart.ShippingExtra && Cart.ShippingExtra.length > 0" class="shipping-extra"><a data-toggle="modal" data-target="#preOrderModal" style="cursor:pointer;"><i class="glyphicon glyphicon-new-window" aria-hidden="true"></i> {{Cart.ShippingExtra}}</a></p>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{Cart.ShippingCosts_FreightAmountToFormat}}</span>
            </div>
        </div>
        <div class="fluid-table-row clearfix" v-show="Cart.ShippingCosts_OrderHandlingAmountToFormat != null">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{getInterfaceText('shop_orderhandlingcosts')}}
                <button v-if="getInterfaceText('shop_orderhandlingCosts_explanation').length > 0" data-toggle="modal" data-target="#orderhandlingModal" style="cursor: pointer; color: inherit; border: none; background: none;"><i class="glyphicon glyphicon-question-sign" aria-hidden="true"></i><span class="sr-only">Open Destination Fee explanation</span></button>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{Cart.ShippingCosts_OrderHandlingAmountToFormat}}</span>
            </div>
        </div>
        <div class="fluid-table-row clearfix" v-if="ProductPriceExcludedTax == true">
            <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_tax')}}</div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right"><span class="cart-tax">{{Cart.TaxToFormat}}</span></div>
        </div>
        <div v-if="ShowGiftcardOrCouponPanel == true">
            <div class="total fluid-table-row clearfix" v-show="Cart.Giftcards && Cart.Giftcards.length > 0">
                <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_total_excluding_giftcards')}}</div>
                <div class="col-md-6 col-sm-6 col-xs-6 text-right">{{Cart.TotalIncludingShippingCostsExcludingGiftcardsToFormat}}</div>
            </div>
            <div class="fluid-table-row clearfix" v-show="Cart.Giftcards && Cart.Giftcards.length > 0">
                <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_amount_covered_by_giftcards')}}</div>
                <div class="col-md-6 col-sm-6 col-xs-6 text-right">{{Cart.GiftcardsTotalToFormat}}</div>
            </div>
        </div>
        <div class="total fluid-table-row clearfix">
            <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_total')}}</div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <span class="cart-total">{{Cart.TotalIncludingShippingCostsToFormat}}</span>
                <div v-if="ShowTaxInclusiveTag">
                    <br /><span style="font-size:10px;font-weight:normal;">{{getInterfaceText('shop_vat_inclusive')}}</span>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="total fluid-table-row clearfix">
            <div class="col-md-6 col-sm-6 col-xs-6 text-left">
                <span class="cart-total-label">{{getInterfaceText('shop_total')}} :</span>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <span class="cart-total">{{Cart.TotalToFormat}}</span>
                <div v-if="ShowTaxInclusiveTag">
                    <br /><span style="font-size:10px;font-weight:normal;">{{getInterfaceText('shop_vat_inclusive')}}</span>
                </div>
            </div>            
        </div>
    </template>
</template>
<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'cart-table',
        mixins: [cartMixin, generalMixin],
        props: ['editMode', 'summaryMode'],
        template: '#cart-table-template',
        data: function () {
            return {
                ProductPriceExcludedTax: false,
                ShowGiftcardOrCouponPanel: false,
                ShowTaxInclusiveTag: false
            }
        },
        methods: {
            // See cartMixin
        },
        computed: {
            // See cartMixin
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
            this.ProductPriceExcludedTax = document.getElementById('vue-cart-parameters').dataset.productpriceexcludedtax == 'true';
            this.ShowGiftcardOrCouponPanel = document.getElementById('vue-cart-parameters').dataset.showgiftcardorcouponpanel == 'true';
            this.ShowTaxInclusiveTag = document.getElementById('vue-cart-parameters').dataset.showtaxinclusivetag == 'true';
        }
    }
</script>
